import { render } from "./DahuaFaceModal.vue?vue&type=template&id=5c848dd6&ts=true"
import script from "./DahuaFaceModal.vue?vue&type=script&lang=ts"
export * from "./DahuaFaceModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__